export { };

declare global {
  interface StringConstructor {
    isValidEmail(value: any): boolean;
    isValidPhone(value: any): boolean;
    isValidCode(value: any): boolean;
  }
}

String.isValidEmail = (value: any) => {
  if (!value) {
    return false;
  }
  const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(value);
};

String.isValidPhone = (value: any) => {
  if (!value) {
    return false;
  }
  const re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  return re.test(value);
};

String.isValidCode = (value: any) => {
  if (!value) {
    return false;
  }
  const re = /^[a-zA-Z0-9\@\_\-]{2,20}$/;
  return re.test(value);
};
